function CommonService(ApiService) {
  'ngInject';
  const service = {};

  service.getParameterByName = function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  service.getAccounts = function(orgId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/accounts.json`, callbackFunc);
  };

  service.getTaxRates = function (orgId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/tax_rates.json`, callbackFunc);
  };

  service.attachmentClass = function(url){
    let splits = url.split('/');
    let fileName = splits[splits.length - 1];
    if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') ||  fileName.endsWith('.png') ||  fileName.endsWith('.svg') ||  fileName.endsWith('.gif')){
      return 'fa fa-file-image-o'; 
    } else if(fileName.endsWith('.xlsx') || fileName.endsWith('.xls') || fileName.endsWith('.odt')){
      return 'fa fa-file-excel-o'; 
    } else if (fileName.endsWith('.docx') || fileName.endsWith('.dotx')){
      return 'fa fa-file-word-o'; 
    } else if (fileName.endsWith('.zip')){
      return 'fa fa-file-archive-o'; 
    } else{
      return 'fa fa-file';
    }
  };

  service.throwError = function(response) {
    let response_string = "";
    let errors_obj = response.errors || response.data.errors || response.data;
    if(Array.isArray(errors_obj))
    {
      for(let i=0; i<errors_obj.length; i++)
      {
        response_string += errors_obj[i] + '. ';
      }
    }else{
      let error_keys = Object.keys(errors_obj)
      let error_values = Object.values(errors_obj);
      for(let i=0; i<error_keys.length; i++)
      {
        if(error_keys[i] != 'full_messages')
        {
          response_string += error_keys[i] + ' ' + error_values[i] + '. ';
        }
      }
    }
    return response_string.replace('api_v1_','').replace('_id', '').replace('_', ' ').trim();
  };

  service.getAttachmentAttributes = function (addedFile, data) {
    let attributes ={
      url: data.url,
      href: data.url
    };
    let file_type = addedFile.type.startsWith('application/') || addedFile.type.startsWith('text/');
    if(file_type){
      attributes["content"] = `
        <span class="trix-preview-file" data-url="${data.url}"  data-name="${addedFile.name}" >
          <div class="file-display">
            <div class="file-desc">
              <span class="name-ellipsis">${addedFile.name}</span>
              <i class="fa fa-file-o"></i>
            </div>
          </div>
        <span>
      `;
    }
    return attributes;
  };

  service.addDescriptionImage = function (data, callbackFunc) {
    ApiService.saveFile(`/base_tasks/description_image_upload.json`, {file: data}, callbackFunc);
  };
  return service;
}

export default{
  name: 'CommonService',
  fn: CommonService
}
